import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Tab,
    Typography,
    TextField,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import dayjs from "dayjs";

const Earnings = () => {
    const navigate = useNavigate();

    const [searchTerm, setSearchTerm] = useState("");
    const [selectedTab, setSelectedTab] = useState(0);
    const [selectedDate, setSelectedDate] = useState("");

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setSelectedTab(newValue);
    };

    // Dummy Earnings Data
    const earningsData = [
        {
            id: 1,
            jobTitle: "Corporate Event Coverage",
            status: "Pending",
            hoursWorked: 6,
            earnings: 800,
            commission: 80,
            payoutStatus: "Pending",
            date: "2024-09-12",
        },
        {
            id: 2,
            jobTitle: "Wedding Photoshoot – Dubai",
            status: "Completed",
            hoursWorked: 8,
            earnings: 1200,
            commission: 120,
            payoutStatus: "Paid",
            date: "2024-08-15",
        },

    ];

    // ✅ Filtering Logic
    const filteredData = earningsData.filter((item) => {
        const matchesTab =
            (selectedTab === 0 && item.status === "Pending") ||
            (selectedTab === 1 && item.status === "Completed");

        const matchesSearch = item.jobTitle
            .toLowerCase()
            .includes(searchTerm.toLowerCase());

        // Show all if no date selected
        const matchesDate = selectedDate ? item.date === selectedDate : true;

        return matchesTab && matchesSearch && matchesDate;
    });

    // ✅ Totals
    const totalEarnings = filteredData.reduce((sum, i) => sum + i.earnings, 0);
    const totalCommission = filteredData.reduce((sum, i) => sum + i.commission, 0);

    return (
        <>
            <div className="main_title">
                <h1>My Earnings</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - My Earnings
                </p>
            </div>
            {/* <div className="custom_tabs1">
                <Tabs
                    value={selectedTab}
                    onChange={handleTabChange}
                    aria-label="earnings tabs"
                    className="custom_tabs_links"
                    sx={{ borderBottom: 1, borderColor: "divider" }}
                >
                    <Tab label="Pending" />
                    <Tab label="Completed" />
                </Tabs></div> */}
            <div className="cards ">
                {/* Tabs for Job Status */}

                {/* Search & Date Filter */}
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mt={3}
                    flexWrap="wrap"
                    gap={2}
                >
                    <SearchBar
                        searchTerm={searchTerm}
                        setDebouncedSearchTerm={setSearchTerm}
                        placeholder="Search job title..."
                    />
                    <div className="form">
                        <TextField
                            type="date"
                            label="Select Date"
                            InputLabelProps={{ shrink: true }}
                            value={selectedDate}
                            onChange={(e) => setSelectedDate(e.target.value)}
                            sx={{ width: 200 }}
                        /></div>
                </Box>

                {/* Summary Section */}
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mt={3}
                    p={2}
                    borderRadius="8px"
                    bgcolor="#f9f9f9"
                    flexWrap="wrap"
                    gap={2}
                >
                    <Typography variant="subtitle1" fontWeight={600}>
                        Total Earnings: <span style={{ color: "#2E7D32" }}>${totalEarnings}</span>
                    </Typography>
                    <Typography variant="subtitle1" fontWeight={600}>
                        Total Commission: <span style={{ color: "#D32F2F" }}>${totalCommission}</span>
                    </Typography>
                    <Typography variant="subtitle1" fontWeight={600}>
                        Net Payout:{" "}
                        <span style={{ color: "#0288D1" }}>
                            ${totalEarnings - totalCommission}
                        </span>
                    </Typography>
                </Box>

                {/* Earnings Table */}
                <TableContainer className="table_container" sx={{ mt: 3 }}>
                    <Table sx={{ minWidth: 750 }} aria-label="earnings table" className="v3">
                        <TableHead>
                            <TableRow hover>
                                <TableCell>Job Title</TableCell>
                                <TableCell>Hours Worked</TableCell>
                                <TableCell>Earnings ($)</TableCell>
                                <TableCell>Commission ($)</TableCell>
                                <TableCell>Payout Status</TableCell>
                                <TableCell>Date</TableCell>

                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredData.length > 0 ? (
                                filteredData.map((item) => (
                                    <TableRow hover key={item.id}>
                                        <TableCell>
                                            <strong>{item.jobTitle}</strong>
                                        </TableCell>
                                        <TableCell>{item.hoursWorked}</TableCell>
                                        <TableCell>${item.earnings}</TableCell>
                                        <TableCell>${item.commission}</TableCell>
                                        <TableCell>{item.payoutStatus}</TableCell>
                                        <TableCell>{dayjs(item.date).format("DD MMM YYYY")}</TableCell>

                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={7} align="center">
                                        No earnings records found for selected filters.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

                {/* Payout Breakdown Buttons */}
                {/* <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
                    <Button variant="outlined" className="btn_primary_outline">
                        View Per Job
                    </Button>
                    <Button variant="outlined" className="btn_primary_outline">
                        View Daily
                    </Button>
                    <Button variant="outlined" className="btn_primary_outline">
                        View Monthly
                    </Button>
                </Box> */}
            </div>
        </>
    );
};

export default Earnings;
